import { render, staticRenderFns } from "./BetslipFooter.vue?vue&type=template&id=b0f336f2&scoped=true"
import script from "./BetslipFooter.vue?vue&type=script&lang=js"
export * from "./BetslipFooter.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooter.vue?vue&type=style&index=0&id=b0f336f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f336f2",
  null
  
)

export default component.exports